import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer
      className="relative py-10 px-6 md:px-12"
      style={{ borderTop: '1px solid rgba(0,212,255,0.1)', background: 'var(--cyber-dark)' }}
      aria-label="Site footer"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        {/* Logo + links */}
        <div className="flex flex-wrap items-center gap-6">
          <AppLogo size={48} />
          <nav className="flex items-center gap-6" aria-label="Footer navigation">
            {[
              { label: 'HOME',       href: '#' },
              { label: 'PRIVACY',    href: '/privacy' },
              { label: 'TERMS',      href: '/terms' },
            ].map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="font-mono text-xs transition-colors duration-200 hover:text-glow-cyan"
                style={{ color: 'rgba(200,216,232,0.35)', letterSpacing: '0.15em' }}
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Social icons */}
        <div className="flex items-center gap-4">
          {[
            { label: 'GitHub',   href: 'https://www.github.com/NiranjanLangade', path: 'M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2z' },
            { label: 'LinkedIn', href: 'https://www.linkedin.com/in/niranjan45', path: 'M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z M4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z' },
            { label: 'YouTube',  href: '#', path: 'M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.8 31.8 0 0 0 0 12a31.8 31.8 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.8 31.8 0 0 0 24 12a31.8 31.8 0 0 0-.5-5.8zM9.6 15.8V8.2L16 12l-6.4 3.8z' },
          ].map((s) => (
            <a
              key={s.label}
              href={s.href}
              className="group transition-all duration-200"
              aria-label={`Visit ${s.label}`}
              style={{ color: 'rgba(200,216,232,0.3)' }}
            >
              <svg
                viewBox="0 0 24 24"
                className="w-4 h-4 transition-all duration-200 group-hover:drop-shadow-[0_0_6px_rgba(0,212,255,0.8)]"
                fill="currentColor"
                style={{ transition: 'color 0.2s' }}
                onMouseEnter={(e) => ((e.currentTarget as SVGElement).style.color = 'var(--cyber-cyan)')}
                onMouseLeave={(e) => ((e.currentTarget as SVGElement).style.color = 'rgba(200,216,232,0.3)')}
              >
                <path d={s.path} />
              </svg>
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p className="font-mono text-[10px]" style={{ color: 'rgba(200,216,232,0.25)', letterSpacing: '0.15em' }}>
          © 2026 NIRANJAN_LANGADE · ALL_RIGHTS_RESERVED
        </p>
      </div>
    </footer>
  );
}
